const rawDataMessageTypeDefinition = {
  1: {
    description: 'Machine Information & Telemetry',
    mqttQos: 1,
    direction: 'Device \u2192 IoT Hub',
    triggeredBy: 'Device',
    legacy: 'No',
    documentation: 'IoT DH Data Model#MachineInformation&Telemetry',
  },
  2: {
    description: 'Replenishment',
    mqttQos: 1,
    direction: 'Device \u2192 IoT Hub',
    triggeredBy: 'Device',
    legacy: 'Yes',
    documentation: 'Still active for brand 2; IoT Reorder v2; Not to be used by new projects, Nespresso specific',
  },
  3: {
    description: 'On-Boarding Request',
    mqttQos: 0,
    direction: 'Device \u2192 IoT Hub',
    triggeredBy: 'Device',
    legacy: 'No',
    documentation: 'IoT DH Data Model#DeviceOnboarding',
  },
  4: {
    description: 'Check For Updates',
    mqttQos: 1,
    direction: 'Device \u2192 IoT Hub',
    triggeredBy: 'Device',
    legacy: 'No',
    documentation: 'MQTT API-Asset Deploy System - PRODUCTION; Ref. Documentation - Asset Deploy; The latest version needs to be used',
  },
  5: {
    description: 'Device Remote Function (f.k.a Remote Control, Remote Function)',
    mqttQos: 0,
    direction: 'IoT Hub \u2192 Biz Backend',
    triggeredBy: 'IoT Hub',
    legacy: 'Yes',
    documentation: 'IoT DH Data Model#LegacyRemoteFunctions; Not to be used by new projects, replaced by the SRF',
  },
  6: {
    description: 'Machine Pairing',
    mqttQos: 1,
    direction: 'Device \u2192 IoT Hub',
    triggeredBy: 'Device',
    legacy: 'Yes',
    documentation: 'Still active for brands 2, 10, 11, 22, 23, 28; IoT DH Data Model#MachinePairing; Not to be used by new projects, replaced by Near Real-Time Notification',
  },
  7: {
    description: 'Market Context Detection (f.k.a Geo IP)',
    mqttQos: 0,
    direction: 'Device \u2192 IoT Hub',
    triggeredBy: 'Device',
    legacy: 'No',
    documentation: 'IoT Hub Market Context Detection',
  },
  10: {
    description: 'Connectivity Test',
    mqttQos: 0,
    direction: 'Device \u2192 IoT Hub',
    triggeredBy: 'Device',
    legacy: 'No',
    documentation: 'IoT DH Data Model#ConnectivityTest',
  },
  11: {
    description: 'Platform Remote Function (f.k.a. Reverse Remote Function, Reverse Remote Control)',
    mqttQos: 0,
    direction: 'Device \u2192 IoT Hub',
    triggeredBy: 'Device',
    legacy: 'Yes',
    documentation: 'Still active for brand 5; IoT DH Data Model#PlatformRemoteFunctionRequest; Not to be used by new projects, Nespresso specific',
  },
  12: {
    description: 'Debug Messages',
    mqttQos: 1,
    direction: 'Device \u2192 IoT Hub',
    triggeredBy: 'Device',
    legacy: 'Yes',
    documentation: 'Rule active for all brands. Only used by brand 5 and 99. Last message from 2018. Not to be used by new projects, Nespresso specific',
  },
  13: {
    description: 'Actionable Event',
    mqttQos: 'N/A',
    direction: 'IoT Hub \u2192 Biz Backend',
    triggeredBy: 'IoT Hub',
    legacy: 'Yes',
    documentation: 'Not to be used by new projects, Nespresso specific',
  },
  14: {
    description: 'Asset Deploy Notification',
    mqttQos: 'N/A',
    direction: 'IoT Hub \u2192 Biz Backend',
    triggeredBy: 'IoT Hub',
    legacy: 'Yes',
    documentation: 'Not to be used by new projects, Nespresso specific',
  },
  15: {
    description: 'IoT Shadow Proxy',
    mqttQos: 1,
    direction: 'Device / IoT Hub',
    triggeredBy: 'Device',
    legacy: 'No',
    documentation: 'IoT Hub Shadow Interaction',
  },
  16: {
    description: 'FOTA Lifecycle Control',
    mqttQos: 1,
    direction: 'Device \u2192 IoT Hub',
    triggeredBy: 'Device',
    legacy: 'No',
    documentation: 'FOTA Lifecycle v2 \u2013 Machine Developers Guide',
  },
  17: {
    description: 'CSR Certificate Renew',
    mqttQos: 0,
    direction: 'Device \u2192 IoT Hub',
    triggeredBy: 'Device',
    legacy: 'No',
    documentation: 'IoT DH Data Model#CSRCertificateRenewal',
  },
  18: {
    description: 'MQTT to HTTP proxy',
    mqttQos: 0,
    direction: 'Device \u2192 IoT Hub',
    triggeredBy: 'Device',
    legacy: 'No',
    documentation: 'Not to be used by new projects; Rule active for all brands',
  },
  19: {
    description: 'Bootstrapping Service (Beta Service, not to be leveraged by production devices)',
    mqttQos: 0,
    direction: 'Device \u2192 IoT Hub',
    triggeredBy: 'Device',
    legacy: 'Yes',
    documentation: 'Not to be used by new projects',
  },
  20: {
    description: 'Cross Device Communication (Beta Service, not to be leveraged by production devices)',
    mqttQos: 0,
    direction: 'Device \u2192 IoT Hub',
    triggeredBy: 'Device',
    legacy: 'Yes',
    documentation: 'Not to be used by new projects',
  },
  21: {
    description: 'IoT Connection Tracking',
    mqttQos: 'N/A',
    direction: 'IoT Hub \u2192 IoT Hub',
    triggeredBy: 'IoT Hub',
    legacy: 'No',
    documentation: "It is a service used just from the IoT Hub, the device doesn't have to do anything to have it working. No rules related to the message type.",
  },
  22: {
    description: 'Secure Remote Functions, Nonce Delivery',
    mqttQos: 0,
    direction: 'Device \u2192 IoT Hub',
    triggeredBy: 'Device',
    legacy: 'No',
    documentation: 'Ref. Documentation - Secure Remote Functions',
  },
  23: {
    description: 'Secure Remote Functions, Function Delivery',
    mqttQos: 0,
    direction: 'IoT Hub \u2192 IoT Hub',
    triggeredBy: 'IoT Hub',
    legacy: 'No',
    documentation: 'Ref. Documentation - Secure Remote Functions',
  },
  24: {
    description: 'Object Ingestion',
    mqttQos: 1,
    direction: 'Device \u2192 IoT Hub',
    triggeredBy: 'Device',
    legacy: 'No',
    documentation: 'Ref. Documentation - API Object Ingestion',
  },
  25: {
    description: 'Configuration Hub',
    mqttQos: 0,
    direction: 'Device \u2192 IoT Hub',
    triggeredBy: 'Device',
    legacy: 'No',
    documentation: 'Ref. Documentation - Device Config Hub',
  },
  28: {
    description: 'Check For Updates Notification for Lifecycle ingestor',
    mqttQos: 'N/A',
    direction: 'IoT Hub \u2192 IoT Hub',
    triggeredBy: 'IoT Hub',
    legacy: 'No',
    documentation: 'It is a service used just from the IoT Hub. No rules related to the message type.',
  },
  29: {
    description: 'Near Real-Time Notification',
    mqttQos: 1,
    direction: 'Device \u2192 IoT Hub',
    triggeredBy: 'Device',
    legacy: 'No',
    documentation: 'Active for brand 10, 28; Platform Near Real Time Notifications',
  },
  30: {
    description: 'Firmware Version Reporting',
    mqttQos: 'N/A',
    direction: 'IoT Hub \u2192 IoT Hub',
    triggeredBy: 'IoT Hub',
    legacy: 'No',
    documentation: 'It is a service used just from the IoT Hub. No rules related to the message type.',
  },
  31: {
    description: 'Device to Backend Pooling operations',
    mqttQos: 'N/A',
    direction: 'Device \u2192 Biz Backend',
    triggeredBy: 'Device',
    legacy: 'No',
    documentation: '',
  },
  32: {
    description: 'Ecosystem topic to send commands from the Hub to the accessory',
    mqttQos: 'N/A',
    direction: 'Hub \u2192 Accessory',
    triggeredBy: 'Hub',
    legacy: 'No',
    documentation: '',
  },
  33: {
    description: 'Ecosystem topic for the accessory to notify the status to the Hub',
    mqttQos: 'N/A',
    direction: 'Accessory \u2192 Hub',
    triggeredBy: 'Accessory',
    legacy: 'No',
    documentation: '',
  },
  1000: {
    description: 'Reserved for Milano Lounge PoC legacy handling',
    mqttQos: 1,
    direction: 'Device \u2192 IoT Hub',
    triggeredBy: 'Device',
    legacy: 'No',
    documentation: '',
  },
  1001: {
    description: 'Reserved for Purina PoC handling',
    mqttQos: 1,
    direction: 'Device \u2192 IoT Hub',
    triggeredBy: 'Device',
    legacy: 'No',
    documentation: '',
  },
  1002: {
    description: 'Reserved for Purina US "Astro" PoC handling',
    mqttQos: 1,
    direction: 'Device \u2192 IoT Hub',
    triggeredBy: 'Device',
    legacy: 'No',
    documentation: '',
  },
};

export default rawDataMessageTypeDefinition;
